import React, { useContext, useEffect, useState, useRef } from 'react'
import moment from 'moment'
import RegistrationLayout from '../../custom/components/templates/RegistrationLayout'
import './registration.css'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import RadioBox from '../../product/components/atoms/RadioBox'
import { useFormik, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { mapData, calculateAge, handleRedirectInternal } from '../../product/common/components'
// import PhoneValidation from './phoneValidation'
import { useHistory } from 'react-router-dom'
import CheckBox from '../../product/components/atoms/CheckBox'
import { Link } from 'react-router-dom'
import AuthContext from '../../product/context/auth/authContext'
import CommonContext from '../../custom/context/common/commonContext'
import ProductCommonContext from '../../product/context/common/commonContext'
import UserContext from '../../product/context/user/userContext'
import { FilterFramesOutlined } from '@material-ui/icons'
import { Document } from 'react-pdf'
import { LOGO } from '../../Utils'
import { parse, isDate } from 'date-fns'
import Popup from '../../custom/components/organisms/Popup'
import FormDialog from '../../custom/components/organisms/Dialog'
import { Button, IconButton, Typography } from '@material-ui/core'
import StripeCustomerContext from '../../product/context/stripe/customer/customerContext'
import NorthCapitalContext from '../../product/context/payment/northcapital/northcapitalContext'
import KlaviyoContext from '../../custom/context/klaviyo/klaviyoContext'
import AlertContext from '../../product/context/alert/alertContext'
import SettingContext from '../../product/context/seller/setting/settingContext'

import Tooltip from '@material-ui/core/Tooltip'
import Loaders from '../../custom/components/molecules/Loaders'
import CustomPopover from '../../custom/components/atoms/Popover'
import { el } from 'date-fns/locale'
import Cryptos from '../../product/common/cryptos'
import CustomDialog from '../../custom/components/organisms/Dialog'
import OwnerDetails from '../Dashboard/Profile/OwnerDetails'
import { gtagEvent } from '../../custom/common/analytics'

let randomVariable = Math.random()

const Verify = (props) => {
    const authContext = useContext(AuthContext)
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)
    const userContext = useContext(UserContext)
    const [isSSN, setSSN] = useState(true)
    const [userType, setUserType] = useState(0)
    const [type, setType] = useState('')
    const [registerUser, setRegisteredUser] = useState(null)
    const [businessClassificationsList, setBusinessClassifications] = useState([])
    const [UserId, setUserId] = useState(null)
    const [currentCountry, setCurrentCountry] = useState()
    const [kycPopup, setKycPopup] = useState(false)
    const [initialPopup, setInititalPopup] = useState(false)
    const { register, user, responseStatus, clearResponse, loadUser } = authContext
    const [toggleDialog, setToggleDialog] = useState(false)
    const [phoneError, setPhoneError] = useState(false)
    const [kycFailPopup, setKycFailPopup] = useState(false)

    const commonContext = useContext(CommonContext)
    const settingContext = useContext(SettingContext)
    const [documentUploaded, setDocumentUploaded] = useState(false)
    const productCommonContext = useContext(ProductCommonContext)
    const {
        updateProfile,
        updatePreference,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
        sendEmailVerifyLink,
        getCompanyOwners,
        company_owner_data,
        runKycCheck,
        updateUserAccountVerified,
    } = userContext
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext
    const [circle, setCircle] = useState({
        emailVerified: false,
        setupPaymentMethod: false,
        completedCompanyInfo: false,
        uploadedCompanyDetails: false,
        addedCompanyOwners: false,
        kycamlChecked: false,
        documentNeeded: true,
        accountVerified: false,
        showkeybtn: false,
        ownerkycamlChecked: false,
    })

    const {
        configFeatures,
        createCustomer,
        dwollaCustomerResponse,
        businessClassifications,
        dwollabusinessClassifications,
    } = commonContext
    const { searchTable, searchTableAction, table_data } = settingContext
    const { static_page, getStaticPage, allCountries, allStates } = productCommonContext

    const { responseStatus: responseStatusStripeCustomer, createStripeCustomer } =
        useContext(StripeCustomerContext)

    const {
        north_capital_card_details,
        northCapitalUser,
        getUserDetails,
        getCreditCard,
        getLinkedCreditCard,
        onBoardEntity,
        onBoardIndividual,
        linkEntityOwner,
        responseStatus: responseStatusNorthCapital,
        uploadPartyDocument,
        uploadEntityDocument,
        responseStatus: responseStatusNorthCapitalsMoreStep,
        north_capital_bank_details,
        getExternalAccount,
        getuploadPartyDocument,
        party_documents,
        party_owner_documents,
        addCampaignContact,
    } = useContext(NorthCapitalContext)
    const { updateProfileAfterRegistration, subscribeProfileToListAfterRegister2 } =
        useContext(KlaviyoContext)
    let [termsLink, setTermsLink] = useState([])
    const [toRunKyc, setToRunKyc] = useState(false)
    let [submitCount, setSubmitCount] = useState('')
    let [zohoRecord, setZohoRecord] = useState({
        email: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        zoho_id: null,
        created_at: null,
    })
    const [currentRegistrationType, setCurrentRegistrationType] = useState(false)
    const [showNonResident, setShowNonResident] = useState(false)
    const [showEntityFields, setShowEntityFields] = useState(false)
    const [inType, setInType] = useState('SSN')
    const [runningKycCheck, setRunningKycCheck] = useState(false)
    const [partyOwnerDocumentLoaded, setPartyOwnerDocumentLoaded] = useState([])
    const [userVerify, setUserVerify] = useState('')
    const [kycProcessed, setKycProcessed] = useState(false)
    const [showPopup, setShowPopup] = useState(false)
    const [kycCommonFailReasons, setKycCommonFailReasons] = useState(false)
    const [companyOwnerData, setCompanyOwnerData] = useState([])
    const [kycAdminReview, setKycAdminReview] = useState(false)
    const [showOwners, setShowOwners] = useState(false)
    const [uploadDocument, setUploadDocument] = useState(false)
    const [reviewPopup, setReviewPopup] = useState(false)
    const [uploadOwnerDocument, setUploadOwnerDocument] = useState(false)
    const [showKycFailedReason, setShowKycFailedReason] = useState(false)
    const [confirmRunKyc, confirmSetRunKyc] = useState(false)
    const [oldUser, setOldUser] = useState('')

    const [is_SSN, setIsSSN] = useState(false)
    const [popup, setPopup] = useState(false)
    const [partyDocuments, setPartyDocuments] = useState([])

    const newRegistration = true

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    // const [phoneVerify, setPhoneVerify] = useState(false)
    // const [disable, setDisable] = useState(false)

    // const changePhoneVerify = () => {
    //     setPhoneVerify(!phoneVerify)
    // }

    // YUP Validation array to ensure all required fields are given values
    const validationArray = [
        Yup.object({
            user_type: Yup.number().required('Required'),
            domicile: Yup.string().required('Required'),
            domesticYN: Yup.string().required('Required'),
            companyname: Yup.string().when('user_type', {
                is: 1,
                then: Yup.string().required('Required'),
            }),
            entityType: Yup.string().when('user_type', {
                is: 1,
                then: Yup.string().required('Required'),
            }),
            entityDesc: Yup.string().when('user_type', {
                is: 1,
                then: Yup.string().required('Required'),
            }),
            first_name: Yup.string().when('user_type', {
                is: 0,
                then: Yup.string()
                    .trim()
                    .matches(/^[0-9a-zA-Z ]*$/g, 'Some kind of special characters not allowed')
                    .max(250, 'Maximum 250 characters')
                    .required('Required'),
            }),
            last_name: Yup.string().when('user_type', {
                is: 0,
                then: Yup.string()
                    .trim()
                    .matches(/^[0-9a-zA-Z ]*$/g, 'Some kind of special characters not allowed')
                    .max(250, 'Maximum 250 characters')
                    .required('Required'),
            }),
            dob: Yup.string().when('user_type', {
                is: 0,
                then: Yup.string().required('Required'),
            }),
            socialsecurity: Yup.string().when(['regType', 'domicile'], {
                is: (regType, domicile) =>
                    // regType === 'individual' ||
                    // domesticYN == 'international_account' ||
                    domicile == 'non-resident',
                then: Yup.string(),
                otherwise: Yup.string()
                    .required('Required!')
                    .test(
                        'len',
                        '9 characters required',
                        (value) => value && value.replace(/_/g, '').replace(/-/g, '').length === 9,
                    ),
            }),
            address1: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Some kind of special characters not allowed')
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            address2: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Some kind of special characters not allowed')
                .max(250, 'Maximum 250 characters'),
            country: Yup.string().trim().required('Required').nullable(),
            city: Yup.string()
                .trim()
                //.matches(/^[0-9a-zA-Z ]*$/g, 'The characters only')
                .matches(/^[a-zA-Z ]*$/g, 'The characters only')
                .required('Required'),
            //state: Yup.string().trim().required('Required!'),
            state: Yup.string().when(['country'], {
                is: (val) => val == 'US' || val == 'CA',
                then: Yup.string().trim().required('Required'),
                otherwise: Yup.string().trim(),
            }),
            zip: Yup.string()
                .trim()
                .min(3, 'Minimum 3 characters Required')
                .max(7, 'Maximum 7 characters Required')
                .required('Required'),
            stripe_id: Yup.string(),
        }),
    ]
    function createStripeUser(userID) {
        if (userType === 1) {
            let entityDesc =
                businessClassificationsList.length > 0
                    ? businessClassificationsList.filter(
                          (data) => data.id === formik.values.entityDesc,
                      )[0]['name']
                    : formik.values.entityDesc
            onBoardEntity(
                {
                    domicile: formik.values.domicile,
                    domesticYN: formik.values.domesticYN,
                    entityName: formik.values.companyname,
                    entityType: formik.values.entityType,
                    entityDesc: entityDesc,
                    ein: formik.values.socialsecurity,
                    primCountry: formik.values.country,
                    primAddress1: formik.values.address1,
                    primAddress2: formik.values.address2,
                    primCity: formik.values.city,
                    primState:
                        formik.values.domesticYN === 'international_account' &&
                        formik.values.domicile == 'non-resident'
                            ? 'NOUS'
                            : formik.values.state,
                    primZip: formik.values.zip,
                    emailAddress: formik.values.email,
                    phone: formik.values.phone,
                    user_id: userID,
                    noAmlCheck: newRegistration ? true : false,
                },
                true,
            )
        } else {
            onBoardIndividual(
                {
                    domicile: formik.values.domicile,
                    domesticYN: formik.values.domesticYN,
                    firstName: formik.values.first_name,
                    lastName: formik.values.last_name,
                    socialSecurityNumber: Cryptos.encrypt(formik.values.socialsecurity),
                    dob: formik.values.dob,
                    primCountry: formik.values.country,
                    primAddress1: formik.values.address1,
                    primAddress2: formik.values.address2,
                    primCity: formik.values.city,
                    primState:
                        formik.values.domesticYN === 'international_account' &&
                        formik.values.domicile == 'non-resident'
                            ? 'NOUS'
                            : formik.values.state,
                    primZip: formik.values.zip,
                    emailAddress: formik.values.email,
                    phone: formik.values.phone,
                    user_id: userID,
                },
                true,
            )
        }
    }

    const ownerFormik = useFormik({
        initialValues: {
            /* filters: {
                    action: {
                        value: '',
                        type: 'in',
                        field: 'tpn.user_id',
                    },
                    searchTerm: {
                        value: '1',
                        type: 'like',
                        field: 'tpn.isOwner',
                    },
                }, */
        },
    })

    const loadCompanyOwners = () => {
        loadUser()
        getCompanyOwners(ownerFormik.values)
    }

    const runKyc = () => {
        setRunningKycCheck(true)
        console.log(user, 'kyc user runn')
        // run kyc for user
        if (
            user.profile_updated === 1 ||
            /* !northCapitalUser.kycstatus ||
            !northCapitalUser.amlstatus */ !circle.kycamlChecked
        ) {
            runKycCheck({ table: 'custom_users', id: user.id })
        }

        if (user.company_owner_updated === 1) {
            if (companyOwnerData && companyOwnerData.length > 0) {
                companyOwnerData.map((item, index) => {
                    if (!item.verified) {
                        runKycCheck({ table: 'company_owners', id: item.id, isOwner: 1 })
                    }
                })
            }
        }
        if (!user.profile_updated && !user.company_owner_updated) {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (responseStatusNorthCapital) {
            console.log(responseStatusNorthCapital, 'respooo')
            if (
                responseStatusNorthCapital.from === 'onBoardIndividual' ||
                responseStatusNorthCapital.from === 'onBoardEntity'
            ) {
                if (responseStatusNorthCapital.status === 'success') {
                    console.log(
                        user?.kyc_check_failed > 0,
                        user?.kyc_check_failed % 2 === 0,
                        user?.user_type !== 1,
                        newProfilePage,
                        '11111111111111111111111',
                    )
                    if (
                        (user?.kyc_check_failed == 0 && user?.user_type !== 1) ||
                        user?.user_type == 1
                    ) {
                        gtagEvent('new_registration_complete', {
                            method: 'email',
                            user_id: user?.id,
                            user_email: user?.email,
                        })
                    }
                    if (window.fbq) {
                        window.fbq('trackCustom', 'Register', {
                            email: formik.values.email,
                            phone: formik.values.phone,
                        })
                    }
                    let value = formik.values
                    if (value.socialsecurity) {
                        value.socialsecurity = Cryptos.encrypt(value.socialsecurity)
                    }
                    value.state =
                        value.domesticYN === 'international_account' &&
                        value.domicile == 'non-resident'
                            ? 'NOUS'
                            : value.state

                    if (
                        value.domesticYN === 'international_account' &&
                        value.domicile == 'non-resident'
                    ) {
                        setShowNonResident(true)
                        if (value.user_type === 1) {
                            setAlert('Please add Company Owners and Documents', 'success')
                        }
                        updateProfile(value, true)
                    } else if (value.user_type === 1) {
                        setShowEntityFields(true)
                        setAlert('Please add Company Owners and Documents', 'success')
                        updateProfile(value, true)
                    } else {
                        setIsLoading(true)
                        updateProfile(value, true)
                        setToRunKyc(true)
                    }
                    if (value.socialsecurity) {
                        value.socialsecurity = Cryptos.decrypt(value.socialsecurity)
                    }
                } else {
                    setIsLoading(false)
                }
            }
        }
    }, [responseStatusNorthCapital])

    const folderName = 'northcapital'

    const validationDoc = Yup.object({
        documentTitle: Yup.string(),
        userfile: Yup.array().required('Required'),
        documentType: Yup.string().required('Required'),
    })

    const validationEnDoc = Yup.object({
        userfile0: Yup.array().required('Required'),
        userfile1: Yup.array().required('Required'),
        userfile2: Yup.array().required('Required'),
        userfile3: Yup.array().required('Required'),
    })

    const documentFormik = useFormik({
        initialValues: {
            documentTitle: '',
            userfile: [],
            attachFolder: folderName,
            documentType: '',
            domicile: '',
        },
        validationSchema: validationDoc,
        onSubmit: (values) => {
            setIsLoading(true)
            uploadPartyDocument(values)
        },
    })

    const entityDocumentFormik = useFormik({
        initialValues: {
            documentTitle: '',
            userfile0: [],
            userfile1: [],
            userfile2: [],
            userfile3: [],
            attachFolder: folderName,
        },
        validationSchema: validationEnDoc,
        onSubmit: (values) => {
            let entityName = user.entityName ? user.entityName : 'NewEntity'
            let documents = []
            for (let i = 0; i < 4; i++) {
                let obj = {
                    documentTitle: entityName + ' Documents',
                    userfile: values[`userfile${i}`],
                    attachFolder: folderName,
                }
                documents.push(obj)
            }
            uploadEntityDocument({ documents })
        },
    })

    const validationSSNArray = [
        Yup.object({
            socialsecurity: Yup.string()
                .required('Required')
                .nullable(true)
                .test(
                    'len',
                    '9 characters required',
                    (value) => value && value.replace(/_/g, '').replace(/-/g, '').length === 9,
                ),
        }),
    ]

    const handleEmailVerify = () => {
        sendEmailVerifyLink({ email: user.email })
    }

    const ssnFormik = useFormik({
        initialValues: {
            socialsecurity: '',
        },
        validationSchema: validationSSNArray[0],
        onSubmit: (values) => {
            let value = values
            if (value.socialsecurity) {
                value.socialsecurity = Cryptos.encrypt(value.socialsecurity)
            }
            updateProfile(value)
        },
    })
    const ssnField = [
        {
            label: 'Social Security Number',
            name: 'socialsecurity',
            placeholder: 'Enter SSN',
            class: `col-12`,
            formik: ssnFormik,
            type: 'hiddenMask',
            maskValue: '***-**-****',
            upperLabel: true,
            startAdornment: <span className="material-icons mr-3">lock</span>,
            modalPP: true,
        },
    ]

    const entityDocumentDetails = {
        formik: entityDocumentFormik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'userfile0',
                titleText:
                    'Upload PDF or JPG: Articles of Incorporation or LLC Operating Agreement',
                innerText: '',
                class: 'col-12  px-0 mt-4',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
            {
                type: 'uploadDropZone',
                name: 'userfile1',
                titleText: 'Upload PDF or JPG: Tax ID Letter (IRS EIN Paperwork)',
                innerText: '',
                class: 'col-12  px-0 mt-4',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
            {
                type: 'uploadDropZone',
                name: 'userfile2',
                titleText: 'Upload PDF or JPG: Valid Photo ID of Officer',
                innerText: '',
                class: 'col-12  px-0 mt-4',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
            {
                type: 'uploadDropZone',
                name: 'userfile3',
                titleText: 'Upload PDF or JPG: State Incorporation/Certification Document',
                innerText: '',
                class: 'col-12  px-0 mt-4',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
        ],
    }

    const getFileExtension = (file) => {
        let fileExtent = /[.]/.exec(file) ? /[^.]+$/.exec(file) : undefined
        if (fileExtent && fileExtent.length) {
            return fileExtent[0]
        } else {
            return ''
        }
    }

    const DocumentUploadRef = useRef(null)
    const gotToDocumentUpload = () => {
        DocumentUploadRef.current?.scrollIntoView({ behavior: 'smooth' })
    }

    useEffect(() => {
        if (party_documents) {
            if (party_documents && party_documents.partyDocumentDetails) {
                party_documents.partyDocumentDetails.map((doc, index) => {
                    /* checkIfImageExists(
                            global.site_url + '/uploads/northcapital/' + doc.documentFileName,
                            (exists) => {
                                if (exists) {
                                    party_documents.partyDocumentDetails[index].doc_url =
                                        global.site_url +
                                        '/uploads/northcapital/' +
                                        doc.documentFileName
                                } else {
                                    party_documents.partyDocumentDetails[index].doc_url =
                                        doc.documentUrl
                                }
                            },
                        ) */

                    let doc_ext = getFileExtension(doc.documentFileName)
                    doc_ext = doc_ext ? doc_ext.toLowerCase() : doc_ext
                    party_documents.partyDocumentDetails[index].doc_ext = doc_ext
                })

                setPartyDocuments(party_documents.partyDocumentDetails)
            }
        }
    }, [party_documents])

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'updateProfile' ||
                responseStatusUser.from === 'mainUpdateProfile' ||
                responseStatusUser.from === 'updatePreference'
            ) {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                    console.log(toRunKyc, 'kuccc')
                    if (toRunKyc) {
                        runKyc()
                        setToRunKyc(false)
                    } else {
                        getUserDetails()
                        setShowPopup(true)
                        setIsLoading(false)
                    }

                    // check the kyc status again
                }
            } else if (responseStatusUser.from == 'runKycCheck') {
                setRunningKycCheck(false)
                confirmSetRunKyc(false)
                //if (responseStatusUser.status === 'success') {
                loadUser()
                getUserDetails()
                setShowPopup(true)
                setIsLoading(false)
                //}
            } else if (responseStatusUser.from == 'updateUserAccountVerified') {
                loadUser()
                getUserDetails()
            }
            clearResponseUser()
        }
    }, [responseStatusUser])

    useEffect(() => {
        if (user) {
            documentFormik.setFieldValue('domicile', user.domicile)
        }
    }, [user])

    useEffect(async () => {
        console.log(responseStatusNorthCapitalsMoreStep, 'responseStatusNorthCapitalsMoreStep')
        if (responseStatusNorthCapitalsMoreStep) {
            if (responseStatusNorthCapitalsMoreStep.from === 'uploadPartyDocument') {
                if (responseStatusNorthCapitalsMoreStep.status === 'success') {
                    console.log(circle?.kycamlChecked, user.domicile, 'circle?.kycamlChecked')
                    if (!circle?.kycamlChecked || circle.completedCompanyInfo) {
                        updateProfile({ profile_updated: 1 }, true)
                        console.log('user?.id111111111111111112222', user?.kyc_check_failed)

                        // if (user?.kyc_check_failed == 2 && user.domicile !== 'non-resident') {
                        //     gtagEvent('new_registration_complete', {
                        //         method: 'email',
                        //         user_id: user?.id,
                        //     })
                        // }
                        if (user.domicile !== 'non-resident') {
                            setReviewPopup(true)
                        }
                    }
                    if (user.user_type !== 1) {
                        runKyc()
                    }
                    // runKyc()
                    console.log('coming on this here')
                    await getUserDetails()
                } else {
                    setIsLoading(false)
                }
            }

            if (responseStatusNorthCapitalsMoreStep.from === 'uploadEntityDocument') {
                if (!circle?.kycamlChecked || circle.completedCompanyInfo) {
                    updateProfile({ profile_updated: 1 }, true)
                    console.log('user?.id1111111111111111333333', user?.kyc_check_failed)

                    if (user.domicile !== 'non-resident') {
                        setReviewPopup(true)
                    }
                }
            }
        }
    }, [responseStatusNorthCapitalsMoreStep])

    // useEffect(() => {
    //     if (responseStatusUser) {
    //         if (responseStatusUser.from === 'updateProfile') {
    //             if (responseStatusUser.status === 'success') {
    //                 loadUser()

    //                 setTimeout(() => {
    //                     if (localStorage.temp_user_id) {
    //                         setToggleDialog(true)
    //                         // handleRedirectInternal(history, 'paymentinfo')
    //                     } else {
    //                         handleRedirectInternal(history, 'search?welcome=1')
    //                     }
    //                 }, 1000)
    //             }
    //         }
    //     }
    // }, [responseStatusUser])

    let registrationTypes = [
        {
            name: 'regType',
            label: 'Individual',
            id: 'individual',
            img: '/assets/svg/individual.svg',
        },
        {
            name: 'regType',
            label: 'Buisness Entity',
            id: 'company',
            img: '/assets/svg/entity.svg',
        },
    ]

    useEffect(() => {
        if (user && Object.keys(user).length) {
            console.log(user, 'userDetails')
            setInType(user.socialSecurityType ? user.socialSecurityType : 'SSN')
            formik.setFieldValue('country', user.country ? user.country : 'US')
            formik.setFieldValue('first_name', user.first_name ? user.first_name : '')
            formik.setFieldValue('last_name', user.last_name ? user.last_name : '')
            formik.setFieldValue('email', user.email ? user.email : '')
            formik.setFieldValue('address1', user.address1 ? user.address1 : '')
            formik.setFieldValue('address2', user.address2 ? user.address2 : '')
            formik.setFieldValue('phone', user.phone ? user.phone : '')
            formik.setFieldValue('city', user.city ? user.city : '')
            formik.setFieldValue('state', user.state ? user.state : '')
            formik.setFieldValue('zip', user.zip ? user.zip : '')
            formik.setFieldValue('dob', user.dob ? user.dob : '')
            formik.setFieldValue('companyname', user.companyname ? user.companyname : '')
            formik.setFieldValue('entityType', user.entityType ? user.entityType : '')
            formik.setFieldValue('entityDesc', user.entityDesc ? user.entityDesc : '')
            formik.setFieldValue('domicile', user.domicile ? user.domicile : '')

            formik.setFieldValue(
                'socialsecurity',
                user.socialsecurity ? Cryptos.decrypt(user.socialsecurity) : '',
            )
            if (user.domesticYN === 'international_account' && user.domicile == 'non-resident') {
                console.log('coming inside this')
                if (user.user_type == 1) {
                    setShowEntityFields(true)
                } else {
                    setShowNonResident(true)
                }
            } else {
                setShowNonResident(false)
            }
            if (user.domesticYN === 'domestic_account' && user.domicile) {
                setShowEntityFields(true)
            } else {
                if (user.user_type !== 1) {
                    setShowEntityFields(false)
                }
            }
            if (user.user_type == 1) {
                formik.setFieldValue('regType', 'company')
            } else {
                formik.setFieldValue('regType', 'individual')
            }
            formik.setFieldValue(
                'socialsecurity',
                user.socialsecurity ? Cryptos.decrypt(user.socialsecurity) : '',
            )
            markAccuntStatus('')
            setUserType(user.user_type)
            if (user.user_type === 1) {
                getCompanyOwners(ownerFormik.values)
            }
            setUserId(user.id)
        }
    }, [user])

    // useEffect(() => {
    //     loadUser()
    //     getUserDetails()
    // }, [])

    useEffect(() => {
        if (dwollaCustomerResponse && Object.keys(dwollaCustomerResponse).length > 0 && UserId) {
            loadUser()
            createStripeUser(UserId)
            setIsLoading(false)
        }
    }, [dwollaCustomerResponse])

    useEffect(() => {
        getStaticPage({ id: 'terms_of_use' })
        businessClassifications()
    }, [])

    useEffect(() => {
        if (dwollabusinessClassifications && dwollabusinessClassifications.length > 0)
            setBusinessClassifications(
                dwollabusinessClassifications[2]['_embedded']['industry-classifications'],
            )
    }, [dwollabusinessClassifications])

    useEffect(() => {
        setTermsLink(static_page?.record?.file_path ? static_page.record.file_path : null)
    }, [static_page])

    useEffect(() => {
        formik.setFieldValue('user_type', userType)
    }, [userType])

    useEffect(() => {
        if (inType) {
            formik.values.socialSecurityType = inType
        }
    }, [inType])

    useEffect(() => {
        //console.log(['uploadDocument', uploadDocument])
        if (confirmRunKyc) {
            if (
                user &&
                user.user_type === 0 &&
                !user.socialsecurity &&
                user.domesticYN != 'international_account'
            ) {
                confirmSetRunKyc(false)
                setIsSSN(true)
                setPopup(true)
            } /* else if (
                    user &&
                    user.kyc_check_failed > 0 &&
                    user.kyc_check_failed % 2 == 0 &&
                    northCapitalUser &&
                    northCapitalUser.isDocumentUploaded === 0
                ) */ else if (uploadDocument) {
                confirmSetRunKyc(false)
                setAlert('Please upload your document', 'error')
            } else if (uploadOwnerDocument) {
                confirmSetRunKyc(false)
                setAlert("Please upload your owner's document", 'error')
            }
        }
    }, [confirmRunKyc])

    useEffect(() => {
        if (userType === 0) setInType('SSN')
    }, [userType])

    const formik = useFormik({
        initialValues: {
            regType: 'individual',
            email: '',
            socialsecurity: '',
            address1: '',
            user_type: 0,
            address2: '',
            phone: '+1',
            country: 'US',
            city: '',
            state: '',
            zip: '',
            status: 'active',
            companyname: '',
            entityType: '',
            entityDesc: '',
            first_name: '',
            last_name: '',
            dob: '',
            domicile: '',
            domesticYN: '',
            is2FAEnabled: '',
            Abandons_Registration: false,
            Type: 'Registration',
            Relationship: ['Registration'],
            profile_updated: 1, //always set this to 1 when
            switchToNewProfile: 1, //always set this to 1 when update profile
        },
        validationSchema: validationArray[0],
        onSubmit: (data) => {
            console.log(data, user, showNonResident, documentUploaded, showNonResident, 'onsubnit ')

            console.log(
                circle.uploadedCompanyDetails && circle.addedCompanyOwners,
                user.domicile,
                user,
                documentUploaded,
                'tyyyy',
            )

            if (
                showNonResident &&
                !documentUploaded &&
                user?.user_type == 0 &&
                user?.domicile == 'non-resident'
            ) {
                setAlert('Please upload Documents', 'error')
            } else if (user.user_type == 1 && user.domicile) {
                if (circle.uploadedCompanyDetails && circle.addedCompanyOwners) {
                    setIsLoading(true)
                    setToRunKyc(true)

                    if (data.socialsecurity) {
                        data.socialsecurity = Cryptos.encrypt(data.socialsecurity)
                    }
                    updateProfile(data, true)
                    if (data.socialsecurity) {
                        data.socialsecurity = Cryptos.decrypt(data.socialsecurity)
                    }
                } else {
                    if (!circle.uploadedCompanyDetails) {
                        setAlert('Please Add Company Documents', 'error')
                    } else {
                        setAlert('Please Add Company Owners', 'error')
                    }
                }
            } else if (user.kyc_check_failed || documentUploaded) {
                setIsLoading(true)
                setToRunKyc(true)

                if (data.socialsecurity) {
                    data.socialsecurity = Cryptos.encrypt(data.socialsecurity)
                }

                updateProfile(data, true)
                if (data.socialsecurity) {
                    data.socialsecurity = Cryptos.decrypt(data.socialsecurity)
                }
            } else {
                if (data.socialsecurity && data.domicile !== 'non-resident') {
                    let regex = /^\d{9}$/
                    if (regex.test(data.socialsecurity)) {
                        createStripeUser(user?.id)
                        setIsLoading(true)
                    } else {
                        setAlert('Please enter valid ssn', 'error')
                    }
                } else {
                    createStripeUser(user?.id)
                    setIsLoading(true)
                }
            }

            // enable when dwollo is disable
        },
    })

    const errorFunc = (data) => {
        setPhoneError(data)
    }

    const markAccuntStatus = (ty) => {
        let accountStatusObj = circle
        accountStatusObj.kycamlChecked = false
        accountStatusObj.addedCompanyOwners = false

        if (ty == 'owner' || user?.user_type === 0) {
            accountStatusObj.addedCompanyOwners = true
            accountStatusObj.ownerkycamlChecked = true
        }

        if (ty == 'kyc') {
            accountStatusObj.kycamlChecked = true
        }

        if (ty == 'payment') {
            accountStatusObj.setupPaymentMethod = true
        }

        if (user && northCapitalUser) {
            accountStatusObj.emailVerified = user && !user.mail_verified ? false : true
            //accountStatusObj.setupPaymentMethod = user.bank_account_type == 'none' ? false : true
            accountStatusObj.documentNeeded =
                user.domesticYN === 'international_account' ||
                //user.regType === 'company' ||
                user.user_type === 1
                    ? true
                    : false
            accountStatusObj.showkeybtn =
                user && (user.company_owner_updated || user.profile_updated) ? true : false

            const individualInternationalUser =
                userType == 0 && user.domesticYN == 'international_account' ? true : false

            /*             if (
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved') &&
                (northCapitalUser?.kycstatus === 'Approved' ||
                    northCapitalUser?.kycstatus === 'Auto Approved' ||
                    northCapitalUser?.kycstatus === 'Manually Approved')
            ) {
                accountStatusObj.kycamlChecked = true
                //accountStatusObj.showkeybtn = false
            } */

            if (
                ((userType === 1 || (userType === 0 && individualInternationalUser)) &&
                    (northCapitalUser?.amlstatus === 'Approved' ||
                        northCapitalUser?.amlstatus === 'Auto Approved' ||
                        northCapitalUser?.amlstatus === 'Manually Approved')) ||
                (userType === 0 &&
                    !individualInternationalUser &&
                    (northCapitalUser?.amlstatus === 'Approved' ||
                        northCapitalUser?.amlstatus === 'Auto Approved' ||
                        northCapitalUser?.amlstatus === 'Manually Approved') &&
                    (northCapitalUser?.kycstatus === 'Approved' ||
                        northCapitalUser?.kycstatus === 'Auto Approved' ||
                        northCapitalUser?.kycstatus === 'Manually Approved'))
            ) {
                accountStatusObj.kycamlChecked = true
                //accountStatusObj.showkeybtn = false
            }

            if (
                accountStatusObj.kycamlChecked ||
                (user.domesticYN === 'international_account' &&
                    user.mail_verified === 1 &&
                    northCapitalUser.isDocumentUploaded === 1) ||
                (user.domesticYN === 'domestic_account' &&
                    user.user_type === 0 &&
                    user.mail_verified === 1) ||
                (user.user_type === 1 && northCapitalUser.isDocumentUploaded === 1)
            ) {
                accountStatusObj.accountVerified = true
                accountStatusObj.uploadedCompanyDetails = true
                if (
                    user &&
                    user.domesticYN !== 'domestic_account' &&
                    user.domicile == 'non-resident' &&
                    northCapitalUser.isDocumentUploaded === 1
                ) {
                    setDocumentUploaded(true)
                    setShowNonResident(false)
                }
            } else {
                accountStatusObj.accountVerified = false

                if (user && user.user_type === 1) {
                    if (northCapitalUser.isDocumentUploaded === 0) {
                        accountStatusObj.uploadedCompanyDetails = false
                    } else {
                        accountStatusObj.uploadedCompanyDetails = true
                    }
                } else if (
                    user &&
                    user.domicile == 'non-resident' &&
                    northCapitalUser.isDocumentUploaded === 0
                ) {
                    accountStatusObj.uploadedCompanyDetails = false
                    setDocumentUploaded(false)
                    setShowNonResident(true)
                } else {
                    accountStatusObj.uploadedCompanyDetails = false
                    if (
                        user &&
                        user.domesticYN !== 'domestic_account' &&
                        user.domicile == 'non-resident' &&
                        northCapitalUser.isDocumentUploaded === 1
                    ) {
                        setDocumentUploaded(true)
                        setShowNonResident(false)
                    }
                }
            }

            if (!user.socialsecurity && user.domicile != 'non-resident') {
                accountStatusObj.completedCompanyInfo = false
            } else {
                accountStatusObj.completedCompanyInfo = true
            }

            if (
                user.user_type === 1 /* &&
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved') */
            ) {
                let companyOwnerVerified = true
                if (
                    company_owner_data &&
                    company_owner_data.record &&
                    company_owner_data.record.length > 0
                ) {
                    company_owner_data.record.map((item, index) => {
                        if (companyOwnerVerified && !item.verified) {
                            companyOwnerVerified = false
                        }
                    })

                    accountStatusObj.addedCompanyOwners = true
                }

                //console.log(companyOwnerVerified)
                if (companyOwnerVerified) {
                    console.log('ssddd')
                    //accountStatusObj.kycamlChecked = true
                    accountStatusObj.ownerkycamlChecked = true
                    accountStatusObj.showkeybtn = false
                } else {
                    //accountStatusObj.kycamlChecked = false
                    accountStatusObj.ownerkycamlChecked = false
                    /* accountStatusObj.showkeybtn = true */
                }
            }

            /* if (
                user.kyc_check_failed > 0 &&
                user.kyc_check_failed % 2 == 0 &&
                northCapitalUser.isDocumentUploaded === 0
            ) {
                setUploadDocument(true)
            } */
        }

        const scrollToTop =
            accountStatusObj?.emailVerified &&
            accountStatusObj?.setupPaymentMethod &&
            accountStatusObj?.completedCompanyInfo &&
            accountStatusObj?.uploadedCompanyDetails &&
            accountStatusObj?.addedCompanyOwners
                ? true
                : false

        if (scrollToTop) {
            window.scrollTo(0, 200)
        }

        if (
            scrollToTop &&
            accountStatusObj?.kycamlChecked &&
            accountStatusObj?.ownerkycamlChecked
        ) {
            setUserVerify(1)
            accountStatusObj.showkeybtn = false
        } else {
            setUserVerify(0)
        }

        console.log(accountStatusObj, '++++')

        if (accountStatusObj?.kycamlChecked) {
            if (user.user_type == 1) {
                // if (accountStatusObj?.ownerkycamlChecked) {
                setKycProcessed(true)
                formik.setFieldValue('profile_updated', 0)
                // } else {
                //     setKycProcessed(false)
                //     formik.setFieldValue('profile_updated', 1)
                // }
            } else {
                setKycProcessed(true)
                formik.setFieldValue('profile_updated', 0)
            }
        } else {
            setKycProcessed(false)
            formik.setFieldValue('profile_updated', 1)
        }

        setCircle(accountStatusObj)
    }

    const newProfilePage = true

    useEffect(() => {
        markAccuntStatus('')
        console.log('changed one')
    }, [northCapitalUser])

    useEffect(() => {
        if (companyOwnerData && companyOwnerData.length > 0) {
            markAccuntStatus('owner')

            /* let tmp_partyOwnerDocumentLoaded = []
                setPartyOwnerDocumentLoaded([])
                companyOwnerData.map((item, index) => {
                    if (tmp_partyOwnerDocumentLoaded.indexOf(item.id) == -1) {
                        if (item.isDocumentUploaded && item.isDocumentUploaded == 1) {
                            tmp_partyOwnerDocumentLoaded.push(item.id)
                            getuploadPartyDocument(
                                {
                                    user_id: item.id,
                                    page: 1,
                                    limit: 20,
                                    order: '',
                                    orderby: '',
                                    isOwner: 1,
                                },
                                true,
                            )
                        }
                    }
                }) */
        }
    }, [companyOwnerData])

    useEffect(() => {
        console.log(circle, 'circle values')
    }, [circle])

    useEffect(() => {
        console.log(company_owner_data, '+++')
        if (
            company_owner_data &&
            company_owner_data.record &&
            company_owner_data.record.length > 0
        ) {
            //markAccuntStatus('owner')

            let syncedUsers = []
            company_owner_data.record.map((item, index) => {
                if ((!item.nc_user || item.nc_user === 0) && syncedUsers.indexOf(item.id) < 0) {
                    item.nc_user = 1
                    syncedUsers.push(item.id)
                } else {
                    syncedUsers.push(item.id)
                }
                item.verified = false

                /* if (
                        (item.amlstatus === 'Approved' ||
                            item.amlstatus === 'Auto Approved' ||
                            item.amlstatus === 'Manually Approved') &&
                        (item.kycstatus === 'Approved' ||
                            item.kycstatus === 'Auto Approved' ||
                            item.kycstatus === 'Manually Approved')
                    ) {
                        item.verified = true
                    } */

                if (
                    (item.domicile == 'non-resident' &&
                        (item.amlstatus === 'Approved' ||
                            item.amlstatus === 'Auto Approved' ||
                            item.amlstatus === 'Manually Approved')) ||
                    (item.domicile != 'non-resident' &&
                        (item.amlstatus === 'Approved' ||
                            item.amlstatus === 'Auto Approved' ||
                            item.amlstatus === 'Manually Approved') &&
                        (item.kycstatus === 'Approved' ||
                            item.kycstatus === 'Auto Approved' ||
                            item.kycstatus === 'Manually Approved'))
                ) {
                    item.verified = true
                }

                /* if (!kycAdminReview && item.kyc_admin_review === 1) {
                        setKycAdminReview(true)
                    } */
            })

            setCompanyOwnerData(company_owner_data.record)
        } else {
            //circle.addedCompanyOwners = false
            setCompanyOwnerData([])
        }
    }, [company_owner_data])

    useEffect(() => {
        setShowKycFailedReason(false)

        if (user && northCapitalUser) {
            if (
                user.kyc_check_failed > 0 &&
                user.kyc_check_failed % 2 == 0 &&
                northCapitalUser.isDocumentUploaded === 0
            ) {
                setUploadDocument(true)
            } else {
                if (northCapitalUser.isDocumentUploaded === 1) {
                    setUploadDocument(false)
                }
            }

            if (user.kyc_admin_review === 1 && user.kyc_check_failed >= 2) {
                setKycAdminReview(true)
            }

            const individualInternationalUser =
                userType == 0 && user.domesticYN == 'international_account' ? true : false
            console.log(northCapitalUser, showPopup, 'northCapitalUser showPopup')
            if (
                ((userType === 1 || (userType === 0 && individualInternationalUser)) &&
                    northCapitalUser.amlstatus === 'Disapproved') ||
                (userType === 0 &&
                    !individualInternationalUser &&
                    (northCapitalUser.amlstatus === 'Disapproved' ||
                        northCapitalUser.kycstatus === 'Disapproved') &&
                    !(
                        northCapitalUser.amlstatus !== 'Auto Approved' &&
                        northCapitalUser.kycstatus !== 'Auto Approved'
                    ))
            ) {
                setShowKycFailedReason(true)
                console.log(showPopup, 'showPopup')
                if (!northCapitalUser.isDocumentUploaded && showPopup && user.user_type == 0) {
                    setKycFailPopup(true)
                    setShowPopup(false)
                }
            }

            if (
                northCapitalUser.amlstatus === 'approved' ||
                northCapitalUser.kycstatus === 'approved'
            ) {
                setAlert('Status Approved Successfully', 'success')

                formik.values.First_Name = formik.values.first_name
                formik.values.Last_Name = formik.values.last_name
                formik.values.Email = formik.values.email
                formik.values.Phone = formik.values.phone
                formik.values.Domicilex = formik.values.domicile
                formik.values.Account_Type =
                    formik.values.domesticYN === 'domestic_account'
                        ? 'Domestic (US)'
                        : 'International'
                formik.values.Date_of_Birth = moment(formik.values.dob).isValid()
                    ? `${moment(formik.values.dob, 'MM-DD-YYYY').format('YYYY-MM-DD')}`
                    : ''
                formik.values.Mailing_Street = `${formik.values.address1} ${formik.values.address2}`
                formik.values.Mailing_State = formik.values.state
                formik.values.Mailing_City = formik.values.city
                formik.values.Mailing_Country = formik.values.country
                formik.values.Mailing_Zip = formik.values.zip

                formik.values.Shipping_Street = `${formik.values.address1} ${formik.values.address2}`
                formik.values.Shipping_State = formik.values.state
                formik.values.Shipping_City = formik.values.city
                formik.values.Shipping_Country = formik.values.country
                formik.values.Shipping_Zip = formik.values.zip

                // formik.values.Email_Opt_In = true
                formik.values.Consent = 'Email'
                formik.values.ource = 'Sign Up'
                formik.values.User_Type = formik.values.regType
                formik.values.Pick_List_5 = formik.values.regType
                addCampaignContact(formik.values, 'Registered', true, true)
                localStorage.setItem('account_verified', true)
                handleRedirectInternal(history, 'paymentInfo')
            } else if (
                northCapitalUser.amlstatus === 'Auto Approved' &&
                northCapitalUser.kycstatus === 'Auto Approved'
            ) {
                setAlert('Status Approved Successfully', 'success')

                formik.values.First_Name = formik.values.first_name
                formik.values.Last_Name = formik.values.last_name
                formik.values.Email = formik.values.email
                formik.values.Phone = formik.values.phone
                formik.values.Domicilex = formik.values.domicile
                formik.values.Account_Type =
                    formik.values.domesticYN === 'domestic_account'
                        ? 'Domestic (US)'
                        : 'International'
                formik.values.Date_of_Birth = moment(formik.values.dob).isValid()
                    ? `${moment(formik.values.dob, 'MM-DD-YYYY').format('YYYY-MM-DD')}`
                    : ''
                formik.values.Mailing_Street = `${formik.values.address1} ${formik.values.address2}`
                formik.values.Mailing_State = formik.values.state
                formik.values.Mailing_City = formik.values.city
                formik.values.Mailing_Country = formik.values.country
                formik.values.Mailing_Zip = formik.values.zip

                formik.values.Shipping_Street = `${formik.values.address1} ${formik.values.address2}`
                formik.values.Shipping_State = formik.values.state
                formik.values.Shipping_City = formik.values.city
                formik.values.Shipping_Country = formik.values.country
                formik.values.Shipping_Zip = formik.values.zip

                // formik.values.Email_Opt_In = true
                formik.values.Consent = 'Email'
                formik.values.ource = 'Sign Up'
                formik.values.User_Type = formik.values.regType
                formik.values.Pick_List_5 = formik.values.regType
                addCampaignContact(formik.values, 'Registered', true, true)
                localStorage.setItem('account_verified', true)
                handleRedirectInternal(history, 'paymentInfo')
            } else {
                if (
                    northCapitalUser.amlstatus === 'Auto Approved' &&
                    user.user_type == 0 &&
                    user.domicile == 'non-resident'
                ) {
                    formik.values.First_Name = formik.values.first_name
                    formik.values.Last_Name = formik.values.last_name
                    formik.values.Email = formik.values.email
                    formik.values.Phone = formik.values.phone
                    formik.values.Domicilex = formik.values.domicile
                    formik.values.Account_Type =
                        formik.values.domesticYN === 'domestic_account'
                            ? 'Domestic (US)'
                            : 'International'
                    formik.values.Date_of_Birth = moment(formik.values.dob).isValid()
                        ? `${moment(formik.values.dob, 'MM-DD-YYYY').format('YYYY-MM-DD')}`
                        : ''
                    formik.values.Mailing_Street = `${formik.values.address1} ${formik.values.address2}`
                    formik.values.Mailing_State = formik.values.state
                    formik.values.Mailing_City = formik.values.city
                    formik.values.Mailing_Country = formik.values.country
                    formik.values.Mailing_Zip = formik.values.zip

                    formik.values.Shipping_Street = `${formik.values.address1} ${formik.values.address2}`
                    formik.values.Shipping_State = formik.values.state
                    formik.values.Shipping_City = formik.values.city
                    formik.values.Shipping_Country = formik.values.country
                    formik.values.Shipping_Zip = formik.values.zip

                    // formik.values.Email_Opt_In = true
                    formik.values.Consent = 'Email'
                    formik.values.ource = 'Sign Up'
                    formik.values.User_Type = formik.values.regType
                    formik.values.Pick_List_5 = formik.values.regType
                    addCampaignContact(formik.values, 'Registered', true, true)
                    localStorage.setItem('account_verified', true)
                    handleRedirectInternal(history, 'paymentInfo')
                }
            }
        }
        console.log(companyOwnerData, 'companyOwner')
        if (companyOwnerData) {
            let ownerDocNeeded = false
            let companyVerified = true
            companyOwnerData.map((item, index) => {
                if (!kycAdminReview && item.kyc_review === 1 && item.kyc_check_failed >= 2) {
                    setKycAdminReview(true)
                }

                if (
                    item.kyc_check_failed > 0 &&
                    item.kyc_check_failed % 2 == 0 &&
                    item.isDocumentUploaded === 0
                ) {
                    //
                    ownerDocNeeded = true
                }

                if (item.amlstatus === 'Disapproved' || item.kycstatus === 'Disapproved') {
                    if (item.kyc_review === 1 && item.kyc_check_failed >= 2) {
                        // console.log('verified')
                        // if (!reviewPopup) {
                        //     setReviewPopup(true)
                        // }
                    } else {
                        setShowKycFailedReason(true)
                        if (showPopup) {
                            setKycFailPopup(true)
                            setShowPopup(false)
                        }
                        companyVerified = false
                    }
                } else {
                    if (!item.verified && companyVerified) {
                        companyVerified = false
                    }
                }
            })

            //console.log(['ownerDocNeeded', ownerDocNeeded])
            if (ownerDocNeeded) {
                setUploadOwnerDocument(true)
            } else {
                setUploadOwnerDocument(false)
                if (companyVerified && companyOwnerData.length) {
                    setAlert('Status Approved Successfully', 'success')

                    formik.values.First_Name = formik.values.first_name
                    formik.values.Last_Name = formik.values.last_name
                    formik.values.Email = formik.values.email
                    formik.values.Phone = formik.values.phone
                    formik.values.Domicilex = formik.values.domicile
                    formik.values.Account_Type =
                        formik.values.domesticYN === 'domestic_account'
                            ? 'Domestic (US)'
                            : 'International'
                    formik.values.Date_of_Birth = moment(formik.values.dob).isValid()
                        ? `${moment(formik.values.dob, 'MM-DD-YYYY').format('YYYY-MM-DD')}`
                        : ''
                    formik.values.Mailing_Street = `${formik.values.address1} ${formik.values.address2}`
                    formik.values.Mailing_State = formik.values.state
                    formik.values.Mailing_City = formik.values.city
                    formik.values.Mailing_Country = formik.values.country
                    formik.values.Mailing_Zip = formik.values.zip

                    formik.values.Shipping_Street = `${formik.values.address1} ${formik.values.address2}`
                    formik.values.Shipping_State = formik.values.state
                    formik.values.Shipping_City = formik.values.city
                    formik.values.Shipping_Country = formik.values.country
                    formik.values.Shipping_Zip = formik.values.zip

                    // formik.values.Email_Opt_In = true
                    formik.values.Consent = 'Email'
                    formik.values.ource = 'Sign Up'
                    formik.values.User_Type = formik.values.regType
                    formik.values.Pick_List_5 = formik.values.regType
                    addCampaignContact(formik.values, 'Registered', true, true)
                    localStorage.setItem('account_verified', true)
                    handleRedirectInternal(history, 'paymentInfo')
                }
            }
        }
    }, [user, northCapitalUser, companyOwnerData])

    const documentDetails = {
        formik: documentFormik,
        data: [
            {
                label: 'Document Type',
                name: 'documentType',
                type: 'select',
                placeholder: 'Select document type',
                class: `documentTypeBtn`,
                upperLabel: true,
                options: [
                    { value: "Driver's License", show: "Driver's License" },
                    { value: 'Passport', show: 'Passport' },
                    { value: 'State ID Card', show: 'State ID Card' },
                ],
            },
        ],
    }

    const uploadDetails = {
        formik: documentFormik, // Use a separate formik instance for upload
        data: [
            {
                label: 'Document',
                type: 'uploadDropZone',
                name: 'userfile', // Retain the same name if needed
                titleText: 'Click here to upload or drag and drop from your computer',
                innerText: '',
                class: 'col-12 px-0 ml-0 mr-3',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
        ],
    }

    const [showUploadedDocuments, setShowUploadedDocuments] = useState(false)

    const viewDoc = (doc) => {
        if (doc) {
            /* const newWindow = window.open(
                    global.site_url + '/uploads/northcapital/' + doc.documentFileName,
                    '_blank',
                    'noopener,noreferrer',
                ) */

            const newWindow = window.open(doc.documentUrl, '_blank', 'noopener,noreferrer')
        }
    }

    useEffect(() => {
        let tmpPartyOwnerDocumentLoaded = [] //partyOwnerDocumentLoaded
        if (party_owner_documents && party_owner_documents.partyDocumentDetails) {
            let docFound = false
            partyOwnerDocumentLoaded.map((doc) => {
                if (!docFound && doc.id == party_owner_documents.partyDocumentDetails[0].id) {
                    docFound = true
                }
            })
            if (!docFound) {
                /* checkIfImageExists(
                        global.site_url +
                            '/uploads/northcapital/' +
                            partyDocumentDetails[0].documentFileName,
                        (exists) => {
                            if (exists) {
                                party_owner_documents.partyDocumentDetails[0].doc_url =
                                    global.site_url +
                                    '/uploads/northcapital/' +
                                    party_owner_documents.partyDocumentDetails[0].documentFileName
                            } else {
                                party_owner_documents.partyDocumentDetails[0].doc_url =
                                    party_owner_documents.partyDocumentDetails[0].documentUrl
                            }
                        },
                    ) */
                let doc_ext = getFileExtension(
                    party_owner_documents.partyDocumentDetails[0].documentFileName,
                )
                doc_ext = doc_ext ? doc_ext.toLowerCase() : doc_ext
                party_owner_documents.partyDocumentDetails[0].doc_ext = doc_ext
                tmpPartyOwnerDocumentLoaded.push(party_owner_documents.partyDocumentDetails[0])
            }
        }

        //setPartyOwnerDocumentLoaded(tmpPartyOwnerDocumentLoaded)
        setPartyOwnerDocumentLoaded((partyOwnerDocumentLoaded) => [
            ...partyOwnerDocumentLoaded,
            ...tmpPartyOwnerDocumentLoaded,
        ])
    }, [party_owner_documents])

    useEffect(() => {
        if (showUploadedDocuments) {
            if (northCapitalUser.isDocumentUploaded && northCapitalUser.isDocumentUploaded === 1) {
                getuploadPartyDocument(
                    {
                        user_id: user.id,
                        page: 1,
                        limit: 20,
                        order: '',
                        orderby: '',
                        isOwner: 0,
                    },
                    true,
                )
            }

            let tmp_partyOwnerDocumentLoaded = []
            setPartyOwnerDocumentLoaded([])
            companyOwnerData.map((item, index) => {
                if (tmp_partyOwnerDocumentLoaded.indexOf(item.id) == -1) {
                    if (item.isDocumentUploaded && item.isDocumentUploaded == 1) {
                        tmp_partyOwnerDocumentLoaded.push(item.id)
                        getuploadPartyDocument(
                            {
                                user_id: item.id,
                                page: 1,
                                limit: 20,
                                order: '',
                                orderby: '',
                                isOwner: 1,
                            },
                            true,
                        )
                    }
                }
            })
        }
    }, [showUploadedDocuments])

    const refreshOwners = () => {
        setShowOwners(false)
        loadUser()
        getCompanyOwners(ownerFormik.values)
    }

    useEffect(() => {
        if (
            formik.values.dob.length > 0 &&
            formik.values.dob.userType != 1 &&
            calculateAge(formik.values.dob) < 18
        ) {
            setAlert('Age must be 18+', 'error')
        }
    }, [formik.values.dob])

    useEffect(() => {
        if (formik.isSubmitting && Object.keys(formik.errors).length) {
            if (document.getElementsByName(Object.keys(formik.errors)[0]).length) {
                document.getElementsByName(Object.keys(formik.errors)[0]).forEach((element) => {
                    element.offsetParent !== null && element.focus()
                })
            }
        }
    }, [formik.errors, formik.isSubmitting])

    // Mapped over for individual registration fields
    const IndividualRegistration = [
        {
            title: [
                <Tooltip title="Are you a US Resident?" arrow={true} placement="top">
                    <span className="cursorDecoy">Domicile</span>
                </Tooltip>,
            ],
            type: 'radio',
            name: 'domicile',
            class: 'col-12 mb-4',
            item: [
                { id: 'U.S. Citizen', description: 'U.S. Citizen' },
                { id: 'U.S. Resident', description: 'U.S. Resident' },
                { id: 'non-resident', description: 'Non-U.S. Resident' },
            ],
            formik: formik,
        },
        {
            title: <span className="cursorDecoy">Account Type</span>,
            type: 'radio',
            name: 'domesticYN',
            class: 'col-12 mb-4',
            item:
                formik.values.domicile === 'non-resident'
                    ? [{ id: 'international_account', description: 'International' }]
                    : [{ id: 'domestic_account', description: 'Domestic (US)' }],
            formik: formik,
        },
        {
            label: 'Entity Name',
            name: 'companyname',
            type: 'text',
            placeholder: 'Enter your entity name',
            class: `col-12 col-sm-6 ${userType === 0 ? 'd-none' : ''}`,
            formik: formik,
            upperLabel: true,
        },
        {
            label: 'Entity Type',
            placeholder: 'Select entity type',
            class: `col-12 col-sm-6 ${userType === 0 ? 'd-none' : ''}`,
            type: 'select',
            options: [
                { value: 'Revocable Trust', show: 'Revocable trust' },
                { value: 'Irrevocable Trust', show: 'Irrevocable trust' },
                { value: 'Limited Partnership', show: 'Limited partnership' },
                { value: 'LLC', show: 'LLC' },
                { value: 'Corporation', show: 'Corporation' },
            ],
            name: 'entityType',
            formik: formik,
            upperLabel: true,
        },
        {
            label: 'Entity Description',
            name: 'entityDesc',
            type: 'select',
            placeholder: 'Enter entity description',
            class: `col-12 col-sm-6 ${userType === 0 ? 'd-none' : ''}`,
            formik: formik,
            upperLabel: true,
            options:
                businessClassificationsList && Array.isArray(businessClassificationsList)
                    ? businessClassificationsList
                          .sort((a, b) => (a.name?.toUpperCase() < b.name?.toUpperCase() ? -1 : 1))
                          .map((buscat) => {
                              let busCategoryChanged = {}
                              busCategoryChanged.show = buscat.name
                              busCategoryChanged.value = buscat.id
                              return busCategoryChanged
                          })
                    : [],
        },
        {
            type: 'misc',
            class: `col-12 ${userType === 1 ? 'd-none' : ''}`,
            content: (
                <div className="registerForm mb-0 ml-0 mr-0 mt-0">
                    <div className="infoWrapper mt-0">
                        <p>
                            <strong>Note</strong>: Enter your first name and last name as they
                            appear on your government ID.
                        </p>
                    </div>
                </div>
            ),
        },
        {
            label: 'First Name',
            name: 'first_name',
            type: 'text',
            placeholder: 'Enter your first name',
            class: `col-12 col-sm-6 ${userType === 1 ? 'd-none' : ''}`,
            // autoFocus: true,
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },
        {
            label: 'Last Name',
            name: 'last_name',
            type: 'text',
            placeholder: 'Enter your last name',
            class: `col-12 col-sm-6 ${userType === 1 ? 'd-none' : ''}`,
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },

        {
            // label: 'Date of Birth',
            label: 'Date of Birth',
            name: 'dob',
            type: 'date',
            placeholder: 'MM-DD-YYYY',
            class: `col-12 col-sm-6 ${userType === 2 ? 'd-none' : ''}`,
            disableFuture: true,
            formik: formik,
            helperText: (
                <CustomPopover
                    label="You must be 18 years old to register"
                    content="Since we will be paying you royalties, minimul age is 18+."
                />
            ),
            upperLabel: true,
            errorMessage: 'Required',
        },
        {
            label:
                userType === 1 ? (
                    <div className="swtchTabs">
                        <p
                            className={`${inType === 'EIN' ? 'activeTab' : ''}`}
                            onClick={() => setInType('EIN')}
                        >
                            <span className="material-icons mr-1">
                                {inType === 'EIN'
                                    ? 'radio_button_checked'
                                    : 'radio_button_unchecked'}
                            </span>{' '}
                            EIN
                        </p>
                        <p
                            className={`${inType === 'SSN' ? 'activeTab' : ''}`}
                            onClick={() => setInType('SSN')}
                        >
                            <span className="material-icons mr-1">
                                {inType === 'SSN'
                                    ? 'radio_button_checked'
                                    : 'radio_button_unchecked'}
                            </span>{' '}
                            SSN
                        </p>
                    </div>
                ) : (
                    'Social Security Number'
                ),
            name: 'socialsecurity',
            placeholder: inType === 'EIN' ? 'Enter EIN' : 'Enter SSN',
            //class: `col-12 col-sm-6  ${formik.values.regType === 'individual' ? 'd-none' : ''}`,
            class: `col-12 col-sm-6 ${formik.values.domicile == 'non-resident' ? 'd-none' : ''} ${
                !user?.socialsecurity ? 'requiredField' : ''
            }`,
            formik: formik,
            type: 'hiddenMask',
            maskValue: inType === 'EIN' ? '**-*******' : '***-**-****',
            upperLabel: true,
            helperText: (
                <CustomPopover
                    label="Why do we need this?"
                    content="We need to collect your SSN to verify your identity in order to make your royalty distribution payments."
                />
            ),
        },
    ]

    useEffect(() => {
        if (formik.values.domesticYN && formik.values.domesticYN === 'domestic_account') {
            formik.setFieldValue('country', 'US')
        } else {
            if (user) {
                formik.setFieldValue('country', user.country ? user.country : 'US')
            }
        }
        if (
            formik.values.regType === 'individual' &&
            formik.values.domesticYN === 'domestic_account'
        ) {
            setSSN(false)
        } else {
            setSSN(true)
        }
    }, [formik.values.regType, formik.values.domesticYN])

    useEffect(() => {
        if (formik.values.domicile === 'non-resident') {
            formik.setFieldValue('domesticYN', 'international_account')
        } else {
            formik.setFieldValue('domesticYN', 'domestic_account')
        }
    }, [formik.values.domicile])

    IndividualRegistration.push(
        {
            label: 'Address Line 1',
            name: 'address1',
            type: 'text',
            placeholder: 'Enter your address',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },
        {
            label: 'Address Line 2',
            name: 'address2',
            type: 'text',
            placeholder: 'Enter your address',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
        },
        {
            label: 'Mobile Number',
            name: 'phone',
            type: 'phone',
            placeholder: 'Mobile number',
            class: 'col-12 col-sm-6',
            formik: formik,
            onError: errorFunc,
            // maxChar: 30,
            // minChar: 2,
            displayFlag: true,
            upperLabel: true,
        },
        {
            label: 'City',
            name: 'city',
            type: 'text',
            placeholder: 'Enter your city',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },
        {
            label: 'State',
            placeholder: 'Select your state',
            class: `col-12 col-sm-6${
                formik.values.country != '' &&
                formik.values.country != 'US' &&
                formik.values.country != 'CA'
                    ? ' d-none'
                    : ''
            }`,
            type: 'select',
            options: allStates
                .filter(
                    (state) =>
                        (formik.values.country
                            ? formik.values.country.indexOf(state.countryCode) !== -1
                            : global.defaultCountry.indexOf(state.countryCode) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1,
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'state',
            formik: formik,
            upperLabel: true,
        },
        {
            label: 'Country',
            placeholder: 'Select your country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter((country) => global.ignoreCountry.indexOf(country.isoCode) === -1)
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'country',
            formik: formik,
            disabled: formik.values.domesticYN === 'domestic_account' ? true : false,
            upperLabel: true,
        },
        {
            label: 'Zip code',
            placeholder: 'Enter your zip code',
            class: 'col-12 col-sm-6',
            type: 'text',
            name: 'zip',
            formik: formik,
            upperLabel: true,
            errorMessage: 'Required',
        },
    )
    // useEffect(() => {
    //     setCurrentCountry(formik.values.country)
    //     if (formik.values.country) formik.setFieldValue('state', '')
    //     if (document.getElementById('register'))
    //         document.getElementById('register').className = 'active'
    // }, [formik.values.country])

    const cancelTemp = () => {
        const id = uuidv4()
        setPopup(id)
    }

    const kycAmlProcess = () => {
        setPopup(false)
    }

    const kycFailedPopup = () => {
        setKycFailPopup(false)
    }

    const kycReviewpopup = () => {
        setReviewPopup(false)
    }

    const ktcActionPopup = () => {
        setKycPopup(false)
    }

    return (
        <RegistrationLayout cancelTemp={cancelTemp} activeStep={2}>
            {isLoading ? (
                <Loaders name="home" isLoading={isLoading} loop={1} className="defaultLoader" />
            ) : showOwners ? (
                <>
                    <OwnerDetails
                        showOwners={showOwners}
                        ownersList={companyOwnerData}
                        loadCompanyOwners={loadCompanyOwners}
                        circle={circle}
                        userDetails={user}
                        backFunction={() => refreshOwners()}
                        backRoute={'verify'}
                        backLabel={'Back to Verify'}
                    />
                </>
            ) : (
                <>
                    <div className="loginWrapper p-5 h-100">
                        <form className="registerForm mb-0 row">
                            <h3 className="mb-4">Verify Identity</h3>
                        </form>
                        <div className="verifyKycHeader">
                            {!circle?.kycamlChecked || !circle?.ownerkycamlChecked ? null : (
                                <span className="lstPrgrs material-icons">check_circle</span>
                            )}

                            {(northCapitalUser?.amlstatus &&
                                northCapitalUser.kycstatus &&
                                user?.user_type != 1 &&
                                user?.domesticYN != 'international_account') ||
                            (northCapitalUser?.amlstatus &&
                                (user?.user_type == 1 ||
                                    (user?.user_type === 0 &&
                                        user?.domesticYN == 'international_account'))) ||
                            kycAdminReview ? (
                                <>
                                    {circle?.kycamlChecked && circle?.ownerkycamlChecked ? (
                                        <div className="statusChip approved">Status: Approved</div>
                                    ) : (
                                        <>
                                            {kycAdminReview ? (
                                                <div className="statusChip notApproved">
                                                    Status: In Admin Review
                                                </div>
                                            ) : (
                                                <>
                                                    {circle?.uploadedCompanyDetails && (
                                                        <div className="statusChip notApproved">
                                                            Status: Not Approved
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                ''
                            )}
                            {showKycFailedReason && (
                                <>
                                    <p className="unVrfdAlrt verifyReason mb-0">
                                        Click&nbsp;
                                        <Link
                                            className="clickHereBtn"
                                            onClick={() => setKycCommonFailReasons(true)}
                                        >
                                            HERE
                                        </Link>{' '}
                                        for common reasons why Verification Failed. <br />
                                        {user?.kyc_check_failed > 0 &&
                                        user?.kyc_check_failed % 2 == 0 ? (
                                            <>
                                                {`Please upload an ID for verification (i.e. Driver's
                                            License, Passport , etc.)`}

                                                {/* <PrimaryButton
                                                        onClick={() => confirmSetRunKyc(true)}
                                                        label="Upload ID"
                                                        btnSize="small"
                                                        disabled={runningKycCheck}
                                                    /> */}
                                            </>
                                        ) : (
                                            <>
                                                {`Please update your information, click "Save" to resubmit your information.`}
                                            </>
                                        )}
                                    </p>

                                    {/* {user?.kyc_check_failed > 0 &&
                                user?.kyc_check_failed % 2 == 0 &&
                                northCapitalUser?.isDocumentUploaded === 0 && (
                                    <PrimaryButton
                                        onClick={() => gotToDocumentUpload()}
                                        label="Upload ID"
                                        btnSize="small"
                                    />
                                )} */}
                                </>
                            )}
                        </div>

                        <div className="rgLyrWrpr  d-flex align-items-center justify-content-center">
                            <div className="vpStepper">
                                <div className="loginWrapper verifyLoginWrapper regLoginWrapper p-5 h-100">
                                    <form
                                        className="registerForm mb-0 row"
                                        onSubmit={formik.handleSubmit}
                                    >
                                        <div className="row w-100">
                                            {!circle?.emailVerified && (
                                                <div className="col-12 emailVerifyCnt">
                                                    Email Not Verified :
                                                    <PrimaryButton
                                                        id="resend_email_verification"
                                                        label="Resend Email Verification"
                                                        btnSize="small"
                                                        onClick={handleEmailVerify}
                                                    />
                                                </div>
                                            )}
                                            <div className="RadioBox col-md-12 mt-3">
                                                <div>
                                                    <label className="radioTitle">User Type</label>
                                                    <div className="d-flex align-items-center">
                                                        {registrationTypes
                                                            .filter(
                                                                (item) =>
                                                                    item.id ==
                                                                    formik.values.regType,
                                                            )
                                                            .map((data, index) => (
                                                                <div
                                                                    className="regType mr-3"
                                                                    key={index}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name={data.name}
                                                                        hidden
                                                                        id={data.id}
                                                                        onChange={
                                                                            formik.handleChange
                                                                        }
                                                                        checked={
                                                                            formik.values.regType ==
                                                                            data.id
                                                                        }
                                                                        value={data.id}
                                                                    />
                                                                    <label htmlFor={data.id}>
                                                                        <img
                                                                            src={data.img}
                                                                            alt=""
                                                                        />
                                                                        <h5>{data.label}</h5>
                                                                        <div className="radioIcon"></div>
                                                                    </label>
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            {/* <div className="registerForm mb-0 ml-0 mr-0 col-12">
                            <div className="infoWrapper">
                                <p>
                                    <strong>Note</strong> : Enter your first name and last name as
                                    they appear on your government ID.
                                </p>
                            </div>
                        </div> */}
                                            {Object.values(mapData(IndividualRegistration))}
                                            {user?.kyc_check_failed > 0 &&
                                                user?.kyc_check_failed % 2 == 0 &&
                                                user?.user_type !== 1 &&
                                                newProfilePage && (
                                                    <>
                                                        <hr />
                                                        <div
                                                            className="col-md-12"
                                                            ref={DocumentUploadRef}
                                                        >
                                                            <p style={{ color: '#B40123' }}>
                                                                Sorry, we were not able to verify
                                                                your identity. Please upload a valid
                                                                ID, like a drivers license or
                                                                passport. We will review the
                                                                information and get back to you ASAP
                                                                to verify your identity.
                                                            </p>
                                                            {/* {user && user.user_type === 1
                                        ? mapData(entityDocumentDetails)
                                        : ''} */}
                                                            {user && user.user_type !== 1
                                                                ? mapData(documentDetails)
                                                                : ''}

                                                            <div className="mt-1 mb-1">
                                                                <div className="customInput mb-0">
                                                                    <label className="mb-0 cstmLable">
                                                                        Document
                                                                        {user &&
                                                                        user.user_type === 1
                                                                            ? 's'
                                                                            : ''}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            {user && user.user_type !== 1
                                                                ? mapData(uploadDetails)
                                                                : ''}
                                                            <div className="uploadBtn">
                                                                <PrimaryButton
                                                                    label="Upload"
                                                                    onClick={() =>
                                                                        user && user.user_type === 1
                                                                            ? entityDocumentFormik.handleSubmit()
                                                                            : documentFormik.handleSubmit()
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                            {/* {newProfilePage && (user?.user_type === 1 || circle?.documentNeeded) && ( */}
                                            {newProfilePage &&
                                                circle?.documentNeeded &&
                                                (showNonResident || showEntityFields) && (
                                                    <>
                                                        <hr />
                                                        <div className=" upldActnFld verifyUploadDocs">
                                                            {circle?.documentNeeded && (
                                                                <>
                                                                    <div className="col-12">
                                                                        <h4 className="mb-4 dashSubtitle">
                                                                            {user?.user_type === 0
                                                                                ? 'Personal ID'
                                                                                : 'Company Documents'}
                                                                            :
                                                                        </h4>

                                                                        <PrimaryButton
                                                                            label="Upload Documents"
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'registration/uploadDocument/1?isupload=1&backTo=verify',
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}

                                                            {user?.user_type === 1 &&
                                                                showEntityFields && (
                                                                    <div className="col-12">
                                                                        <h4 className="mb-4 dashSubtitle">
                                                                            Company Owners:
                                                                        </h4>
                                                                        <PrimaryButton
                                                                            label="Add / View Company Owners"
                                                                            onClick={() =>
                                                                                setShowOwners(true)
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </>
                                                )}
                                        </div>
                                        {!(
                                            user?.kyc_check_failed > 0 &&
                                            user?.kyc_check_failed % 2 == 0 &&
                                            user?.user_type !== 1
                                        ) ? (
                                            <div className="regActBox mt-2">
                                                <PrimaryButton
                                                    id="register_button"
                                                    label="SAVE"
                                                    type="submit"
                                                    onClick={() => formik.handleSubmit()}
                                                />
                                            </div>
                                        ) : null}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <FormDialog
                        className="bidAskPopup prflAlrtPopup text-left"
                        open={kycCommonFailReasons}
                        openFunction={() => setKycCommonFailReasons(false)}
                        maxWidth={'sm'}
                        title={
                            <div className="ttleCntnr d-flex align-items-center justify-content-between">
                                Common Reasons for Verification Failure
                                <IconButton onClick={() => setKycCommonFailReasons(false)}>
                                    <span className="material-icons">clear</span>
                                </IconButton>
                            </div>
                        }
                    >
                        {/* <p className="mb-4 text-left">
                                    List the common reasons for kyc failure
                                </p> */}

                        <h5 className="mb-3">For Individuals</h5>
                        <p className="fa-sm">
                            Your personal information does not match the information on your ID
                            <br />
                            Please check the following items and re-submit:
                        </p>
                        <ul className="fa-sm">
                            <li>First Name</li>
                            <li>Last Name</li>
                            <li>Address</li>
                            <li>SSN</li>
                        </ul>

                        <h5 className="mb-3 mt-4">For Entities</h5>
                        <p className="fa-sm">
                            Your company information does not match what has been filed.
                            <br />
                            Please check the following items and re-submit:
                        </p>
                        <ul className="fa-sm">
                            <li>Company Name</li>
                            <li>Company Address</li>
                            <li>Company Documents</li>
                            <li>Company EIN</li>
                            <li>
                                {`Company Owners' Information`}
                                <ul>
                                    <li>First Name</li>
                                    <li>Last Name</li>
                                    <li>Address</li>
                                    <li>SSN</li>
                                </ul>
                            </li>
                        </ul>
                    </FormDialog>

                    <CustomDialog
                        open={popup}
                        className="kycAmlModal"
                        handleClose={() => {
                            setPopup(false)
                        }}
                        function={kycAmlProcess}
                        title="Verification Process"
                    >
                        <>
                            {isSSN && (
                                <form onSubmit={ssnFormik.handleSubmit} autoComplete="nofill">
                                    <div className="row">{Object.values(mapData(ssnField))}</div>
                                    <div className="bdyContent">
                                        <p>Why do we need this?</p>
                                        <p className="descTxt">
                                            We are required by federal law (USA PATRIOT Act) to
                                            collect your Social Security Number. This is only used
                                            to verify your identity and to protect against fraud and
                                            money laundering
                                        </p>
                                        <div className="lckDesc d-flex align-items-center mt-4">
                                            <span className="material-icons">lock</span>
                                            <div className="rtCntnr ml-3">
                                                <p className="crdtTtl">Your Credit Score is safe</p>
                                                <p className="cdtlDesc">
                                                    We only use SSN to verify your identity. This
                                                    has no impact on your credit score.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <PrimaryButton
                                                // disabled={disabled}
                                                // btnSize="large"
                                                type="submit"
                                                label={'Save'}
                                            />
                                        </div>
                                    </div>
                                </form>
                            )}
                        </>
                    </CustomDialog>

                    <CustomDialog
                        open={kycFailPopup}
                        className="kycAmlModal"
                        // size="sm"
                        handleClose={() => {
                            setKycFailPopup(false)
                        }}
                        function={kycFailedPopup}
                        title="Verification Process"
                    >
                        <>
                            <div className="bdyContent">
                                <p>Verification Failed</p>
                                <p className="descTxt">
                                    {user?.kyc_check_failed > 0 &&
                                    user?.kyc_check_failed % 2 == 0 ? (
                                        <>
                                            We are still unable to verify your identity. Please
                                            upload a current ID (i.e. drivers license or passport)
                                            for verification.
                                        </>
                                    ) : (
                                        <>
                                            There was an issue verifying your identity. Please
                                            ensure your birthdate, name and address match your most
                                            recent ID.
                                        </>
                                    )}
                                </p>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <PrimaryButton
                                        // disabled={disabled}
                                        // btnSize="small"
                                        onClick={() => setKycFailPopup(false)}
                                        label={'Close'}
                                    />
                                </div>
                            </div>
                        </>
                    </CustomDialog>

                    <CustomDialog
                        open={reviewPopup}
                        className="kycAmlModal"
                        // size="sm"
                        handleClose={() => {
                            setReviewPopup(false)
                            localStorage.setItem('account_verified', true)
                            handleRedirectInternal(history, 'paymentInfo')
                        }}
                        title="Review In Progress"
                        function={kycReviewpopup}
                    >
                        <>
                            <div className="bdyContent">
                                <p className="descTxt">
                                    We’ve received your ID and will notify you by email once
                                    verified. You can also check the status in your Settings.
                                </p>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <PrimaryButton
                                        // disabled={disabled}
                                        btnSize="large"
                                        onClick={() => {
                                            setReviewPopup(false)
                                            localStorage.setItem('account_verified', true)
                                            handleRedirectInternal(history, 'paymentInfo')
                                        }}
                                        label={'Close'}
                                    />
                                </div>
                            </div>
                        </>
                    </CustomDialog>

                    <CustomDialog
                        open={kycPopup}
                        className="kycAmlModal"
                        // size="md"
                        handleClose={() => {
                            setKycPopup(false)
                        }}
                        title="Action Required: Complete SEC Verification"
                        function={ktcActionPopup}
                    >
                        <>
                            <div className="bdyContent">
                                <p className="descTxt">
                                    You have selected to Auto Purchase shares. Currently, your
                                    contact information is not correct, or we need additional
                                    information to complete SEC verification of your identity.
                                    Please review that all the steps on this settings page are
                                    green, including the last step{' '}
                                    <strong>{'Run KYC and AML Check'}</strong>
                                    <br />
                                    Which should be marked Status: <strong>Approved</strong>.
                                    <br /> You may be asked to update your contact information or
                                    upload a valid ID to complete this verification process. Once
                                    this is complete, your Auto Purchase will automatically be
                                    active.
                                </p>
                            </div>
                            <div className="row">
                                {/* <div className="col-12">
                                                    <PrimaryButton
                                                        // disabled={disabled}
                                                        btnSize="large"
                                                        onClick={() => setKycPopup(false)}
                                                        label={'Confirm'}
                                                    />
                                                </div> */}
                            </div>
                        </>
                    </CustomDialog>

                    <FormDialog
                        className="bidAskPopup prflAlrtPopup"
                        open={showUploadedDocuments}
                        openFunction={() => setShowUploadedDocuments(false)}
                        maxWidth={'md'}
                        title={
                            <div className="ttleCntnr d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Documents Uploaded</h4>
                                <IconButton onClick={() => setShowUploadedDocuments(false)}>
                                    <span className="material-icons">clear</span>
                                </IconButton>
                            </div>
                        }
                    >
                        <div className="row">
                            <div className="col-md-12 mb-4">
                                <div className="table-responsive dpTable">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="text-left" style={{ width: '50%' }}>
                                                    Document Title
                                                </th>
                                                <th className="text-left" style={{ width: '32%' }}>
                                                    Created Date
                                                </th>
                                                <th className="text-center">Document</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {partyDocuments &&
                                                partyDocuments.length > 0 &&
                                                partyDocuments.map((docs, key) => (
                                                    <tr>
                                                        <td className="text-left">
                                                            {unescape(docs.documentTitle)}
                                                        </td>
                                                        <td className="text-left">
                                                            {docs.createdDate}
                                                        </td>
                                                        <td>
                                                            <aside className="thumbsContainer mt-0 mr-0">
                                                                <div className="thumb mr-0">
                                                                    <div className="thumbCnt">
                                                                        {docs.doc_ext == 'pdf' ? (
                                                                            <>
                                                                                <div className="defaultThumb">
                                                                                    <span className="material-icons">
                                                                                        picture_as_pdf
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <img
                                                                                    src={`${docs.documentUrl}`}
                                                                                    className="img"
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </aside>

                                                            <Link
                                                                className="ml-2"
                                                                onClick={() => viewDoc(docs)}
                                                            >
                                                                Download
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}

                                            {partyOwnerDocumentLoaded &&
                                                partyOwnerDocumentLoaded.length > 0 && (
                                                    <>
                                                        <tr>
                                                            <td colSpan="3" className="text-left">
                                                                <h5 className="mb-0">
                                                                    Owner Documents Uploaded
                                                                </h5>
                                                            </td>
                                                        </tr>

                                                        {partyOwnerDocumentLoaded.map(
                                                            (docs, key) => (
                                                                <tr>
                                                                    <td className="text-left">
                                                                        {unescape(
                                                                            docs.documentTitle,
                                                                        )}
                                                                    </td>
                                                                    <td className="text-left">
                                                                        {docs.createdDate}
                                                                    </td>
                                                                    <td>
                                                                        <aside className="thumbsContainer mt-0 mr-0">
                                                                            <div className="thumb mr-0">
                                                                                <div className="thumbCnt">
                                                                                    {docs.doc_ext ==
                                                                                    'pdf' ? (
                                                                                        <>
                                                                                            <div className="defaultThumb">
                                                                                                <span className="material-icons">
                                                                                                    picture_as_pdf
                                                                                                </span>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <img
                                                                                                src={`${docs.documentUrl}`}
                                                                                                className="img"
                                                                                            />
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </aside>

                                                                        <Link
                                                                            className="ml-2"
                                                                            onClick={() =>
                                                                                viewDoc(docs)
                                                                            }
                                                                        >
                                                                            Download
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            ),
                                                        )}
                                                    </>
                                                )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </FormDialog>
                </>
            )}
        </RegistrationLayout>
    )
}

export default Verify
